import React, { useState, useRef } from 'react';
import { api } from '../lib/api';
import { Upload, Loader2, ImageIcon, X } from 'lucide-react';
import { Input } from './ui/input';

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

export function resolveImageUrl(url) {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  // Static build on Hostinger: rewrite both /api/uploads/ and /uploads/
  // to be served from the SAME ORIGIN (i.e. /uploads/...) so images load even
  // if the Render free-tier backend disk got wiped.
  if (url.startsWith('/api/uploads/')) return url.replace('/api/uploads/', '/uploads/');
  if (url.startsWith('/uploads/')) return url;
  return url;
}

export default function ImageUpload({ value, onChange, label = 'Image', placeholder = 'Paste image URL or upload' }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await api.post('/admin/upload', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      onChange(data.url);
    } catch (e) {
      alert('Upload failed: ' + (e?.response?.data?.detail || 'Try again'));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      {label && <label className="text-sm font-medium">{label}</label>}
      <div className="mt-1 flex gap-2 items-start">
        <div className="flex-1 space-y-2">
          <Input value={value || ''} onChange={e => onChange(e.target.value)} placeholder={placeholder} />
          <div className="flex items-center gap-2">
            <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={e => upload(e.target.files?.[0])} />
            <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading}
              className="inline-flex items-center gap-1.5 text-xs bg-gray-100 hover:bg-gray-200 px-3 py-1.5 rounded disabled:opacity-50">
              {uploading ? <><Loader2 className="w-3.5 h-3.5 animate-spin" /> Uploading...</> : <><Upload className="w-3.5 h-3.5" /> Upload file</>}
            </button>
            {value && <button type="button" onClick={() => onChange('')} className="inline-flex items-center gap-1 text-xs text-red-600 hover:bg-red-50 px-2 py-1 rounded"><X className="w-3 h-3" /> Clear</button>}
          </div>
        </div>
        <div className="w-24 h-24 border border-gray-200 rounded bg-[#fff7e6] flex items-center justify-center shrink-0 overflow-hidden">
          {value ? <img src={resolveImageUrl(value)} alt="preview" className="max-w-full max-h-full object-contain" /> : <ImageIcon className="w-6 h-6 text-gray-300" />}
        </div>
      </div>
    </div>
  );
}
